import { Dialog } from "construct-ui";
import paginationComponent from '../../components/pagination/pagination.component';
import { getSEAOVendorList, saveSEAOVendor } from "../../models/retail-asset-management/seao-posm-master.model";
import ViewBase from "../view-base.view";

export default function SEAOPOSMVendorManagement() {
  ViewBase.call(this);

  const DESCENDING_TEXT = 'DESC';
  const ASCENDING_TEXT = 'ASC';

  const ATTRIBUTES = {
    VENDOR_ID: 'vendorId',
    VENDOR_NAME: 'vendorName',
  }

  const DEFAULT_ITEM = {
    vendorId: 0,
    vendorName: '',
    active: true
  }

  let vendors = []
  let searchText = '';
  let totalItems = 0;
  let pageSize = 10;
  let pageIndex = 1;
  let isCreateDialogOpen = false;
  let selectedVendor = structuredClone(DEFAULT_ITEM);
  let selectedOrderBy = '';
  let selectedSortBy = '';

  const getAllVendor = () => {
    this.showLoading();
    getSEAOVendorList({
      VendorName: searchText,
      Active: true,
      CreatedBy: '',
      FromDate: '',
      ToDate: '',
      PageSize: pageSize,
      PageIndex: pageIndex,
      SortBy: selectedSortBy || ATTRIBUTES.VENDOR_ID,
      OrderBy: selectedOrderBy || DESCENDING_TEXT,
    })
      .then((data) => {
        totalItems = data.total
        vendors = data.data
      }).catch((err) => {
        this.handleError(err);
      }).finally(() => {
        this.hideLoading();
      });
  }
  const onSearch = (text) => {
    pageIndex = 1;
    pageSize = 10;
    getAllVendor(text);
  }

  const handleClickDelete = (item) => {
    this.showConfirm(
      this.getText("EM00000265", "Are you sure you want to delete?"),
      this.getText("LT00000373", "Remove Selected"),
      (e) => {
        if (e == "YES") {
          this.showLoading();
          saveSEAOVendor({ ...item, active: false })
            .then((data) => {
              if (data.transStatus == "SUCCESS") {
                this.showMessage(this.getText("LT00001077", "Item deleted successfully"), this.getText('EM00000004', 'Success'), getAllVendor);
              } else {
                this.showErrorMessage(data[0].message)
              }
            })
            .catch((err) => {
              this.handleError(err);
            })
            .finally(() => {
              this.hideLoading()
            })
        }
      }
    )
  }
  const handleOpenDialog = () => {
    isCreateDialogOpen = true;
  }
  const handleCloseDialog = () => {
    isCreateDialogOpen = false;
  }

  const handleClickAdd = () => {
    handleOpenDialog();
    selectedVendor = structuredClone(DEFAULT_ITEM)
  }

  const handleClickUpdate = (item) => {
    handleOpenDialog();
    selectedVendor = structuredClone(item);
  }
  const onSave = (e) => {
    e.preventDefault();
    if (!this.validateForm(e)) {
      return false;
    }
    this.showLoading();
    saveSEAOVendor(selectedVendor)
      .then((data) => {
        if (data.transStatus == "SUCCESS") {
          this.showMessage(
            selectedVendor.vendorId ? this.getText("LT00001016", "Item edited successfully") : this.getText("LT00001018", "Item added successfully"),
            this.getText('EM00000004', 'Success'),
            () => {
              handleCloseDialog();
              getAllVendor();
            }
          );
        } else {
          this.showErrorMessage(data.message)
        }
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading()
      })

  }

  const _flipOrderText = (orderText) => {
    return orderText.toUpperCase() === DESCENDING_TEXT ? ASCENDING_TEXT : DESCENDING_TEXT
  }

  const _getSortIcon = (orderBy) => {
    if (selectedSortBy !== orderBy) {
      return null
    }
    return selectedOrderBy === DESCENDING_TEXT ? m('i.bi.bi-sort-down') : m('i.bi.bi-sort-up')
  }

  const _onSortClick = (orderBy) => {
    if (selectedSortBy === orderBy) {
      selectedOrderBy = _flipOrderText(selectedOrderBy)
    } else {
      selectedSortBy = orderBy;
      selectedOrderBy = DESCENDING_TEXT;
    }
    getAllVendor();
  }

  return {
    oninit: () => {
      getAllVendor();

    },
    view: () => [
      m('.text-end.mb-3',
        m('button.btn.btn-primary',
          {
            onclick: handleClickAdd,
            title: this.getText('LT00000090', 'Add')
          },
          m("i.bi.bi-plus-lg.me-0"),
        )
      ),
      m('.card.mb-3',
        m('.card-body',
          m('.position-relative',
            m('.row.g-2.mb-2',
              m('.col-4.position-relative',
                m('label.form-label', this.getText('LT00001088', 'Vendor')),
                m('input[type=text].form-control.form-control-bg', {
                  placeholder: this.getText('LT00001088', 'Vendor'),
                  oninput: (e) => {
                    searchText = e.target.value;
                  },
                  value: searchText,
                }),
              )
            ),
            m('.d-flex.justify-content-between.gap-2.position-absolute.bottom-0.end-0',
              m(
                'button.btn.btn-primary',
                {
                  onclick: () => {
                    onSearch(searchText)
                  },
                },
                this.getText('LT00000001', 'Search')
              ),
              m(
                'button.btn.btn-white',
                {
                  onclick: () => {
                    searchText = "";
                  },
                },
                this.getText('LT00000031', 'Clear')
              )
            ),
          )
        )
      ),
      m('.card',
        m('.card-body',
          m('.row',
            m(".col-12.p-0",
              m(".table-responsive",
                m("table.table.table-hover.table-bordered", [
                  m("thead",
                    m("tr.align-middle", [
                      m("th.text-center", { "scope": "col", "style": "width: 180px;" },
                        this.getText('LT00000092', 'Action')
                      ),
                      m("th.text-center", {
                        scope: "col",
                        onclick: () => { _onSortClick('vendorId') },
                      },
                        _getSortIcon('vendorId'),
                        this.getText('LT00001289', 'Vendor ID')),
                      m("th.text-center", {
                        scope: "col",
                        onclick: () => { _onSortClick('vendorName') },
                      },
                        _getSortIcon('vendorName'),
                        this.getText('LT00001088', 'Vendor')),
                    ]),

                  ),
                  m("tbody",
                    (vendors.length === 0) &&
                    m("tr", { "class": "align-middle" },
                      m("td", { "colspan": 2 }, this.getText("EM00000141", "No records found."))
                    ),
                    vendors.length > 0 &&
                    vendors.map((att, index) => {
                      return [
                        m("tr.align-middle", [
                          m("td", { "style": "text-align :center; max-width:100px;" },
                            [
                              m('i.bi.bi-trash-fill.list-action-icon[title="Delete"]', {
                                onclick: () => { handleClickDelete(att) }
                              }),
                              m('i.bi.bi-pencil-square.list-action-icon[title="Edit"]', {
                                onclick: () => { handleClickUpdate(att) }
                              })
                            ]
                          ),
                          m("td", att.vendorId),
                          m("td", att.vendorName),
                        ]),
                      ]
                    }),
                  )
                ])
              ),
              vendors.length > 0 &&
              m(".px-3",
                m(paginationComponent, {
                  currentPage: pageIndex,
                  pageSize: pageSize,
                  totalItems: totalItems,
                  onPageChanged: (newPageIndex) => {
                    pageIndex = newPageIndex;
                    getAllVendor();

                  },
                  onPageSizeChanged: (newPageIndex, newPageSize) => {
                    pageIndex = newPageIndex;
                    pageSize = newPageSize;
                    getAllVendor()
                  },
                })
              )
            )
          )
        )
      ),
      //End List

      m(Dialog, {
        isOpen: isCreateDialogOpen,
        closeOnOutsideClick: false,
        closeOnEscapeKey: false,
        title: selectedVendor.vendorId ? `${this.getText('LT00001088', 'Vendor')}(${selectedVendor.vendorId})` : `${this.getText('LT00001335', 'New')} ${this.getText('LT00001088', 'Vendor')}`,
        class: 'cui-dialog-xxl',
        onClose: handleCloseDialog,
        content: m('.card',
          m('.card-body',
            m('form.needs-validation[novalidate]', { id: 'form', onsubmit: onSave },
              m('.row.g-2',
                m('.col-md-12.position-relative',
                  m('label.form-label.mandatory[for="input"]',
                    `${this.getText('LT00001088', 'Vendor')}`
                  ),
                  m(`input#input.form-control.form-control-bg[required][type=text][placeholder=${this.getText('LT00001088', 'Vendor')}]`, {
                    maxlength: 100,
                    defaultValue: selectedVendor.vendorName,
                    oninput: (e) => { selectedVendor.vendorName = e.target.value }

                  }),
                  m('.invalid-tooltip', this.getText('LT00000903', 'Please check required fields')),
                )
              )
            )
          ),
        ),
        footer: m('row',
          m('.col-12.d-flex.justify-content-end.gap-2',
            m('button.btn.btn-primary',
              {
                type: 'submit',
                form: 'form',
              },
              this.getText('LT00000022', 'Save')
            ),
            m('button.btn.btn-white',
              {
                onclick: handleCloseDialog,
              },
              this.getText('LT00000021', 'Close')
            )
          )
        ),
      }),
      this.getBaseViews(),
    ],

  }
}